import { render, staticRenderFns } from "./langSelect.vue?vue&type=template&id=b7a317dc&scoped=true"
import script from "./langSelect.vue?vue&type=script&lang=js"
export * from "./langSelect.vue?vue&type=script&lang=js"
import style0 from "./langSelect.vue?vue&type=style&index=0&id=b7a317dc&prod&lang=less&scoped=true"
import style1 from "./langSelect.vue?vue&type=style&index=1&id=b7a317dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a317dc",
  null
  
)

export default component.exports